import { Fragment } from "react";
import { MenuDivider } from "./MenuDivider";
import { MenuHeader } from "./MenuHeader";
import { MenuOptionItem } from "./MenuOptionItem";
import type { IMenuItem } from "./types";
import {
  isMenuCustomElement,
  isMenuDivider,
  isMenuHeader,
  isMenuOption,
} from "./types";

type Props = {
  options: IMenuItem[];
};

export const MenuContent = ({ options }: Props) => {
  let optionIndex = 0;

  // Arrow keys move real focus between items, so no aria-activedescendant.
  return (
    <div className="nuco-menu__option-wrapper">
      {options.map((item, index) => {
        if (isMenuDivider(item)) {
          return <MenuDivider key={index} item={item} />;
        }

        if (isMenuHeader(item)) {
          return <MenuHeader key={index} item={item} />;
        }

        if (isMenuCustomElement(item)) {
          return <Fragment key={index}>{item.element}</Fragment>;
        }

        if (isMenuOption(item)) {
          const currentIndex = optionIndex;
          optionIndex++;
          return (
            <MenuOptionItem key={item.id} option={item} index={currentIndex} />
          );
        }

        return null;
      })}
    </div>
  );
};
